import React, {useState} from "react";
import axios from 'axios';
import "./Weather.css"
import FormatDate from "./FormatDate";
import WeatherIcon from "./WeatherIcon";
import WeatherTemperature from "./WeatherTemperature";
import WeatherForecast from "./WeatherForecast";


export default function Weather(props) {
    const [ready,setReady] = useState(false);
    const [city,setCity] = useState(props.defaultCity);
    const [weatherData, setweatherData] = useState({});
    function handleResponse(response) {
        setReady(true);
        
        setweatherData({
            coordinates: response.data.coord,
            Temperature:response.data.main.temp,
            wind: response.data.wind.speed,
            humidity: response.data.main.humidity,
            date: new Date(response.data.dt * 1000),
            description: response.data.weather[0].description,
            city: response.data.name,
            icon: response.data.weather[0].icon
        });
        
    }
        function searching() {
            const apiKey = "094780c710fa4efd669f0df8c3991927";
            let apiUrl = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKey}&units=metric`;
            axios.get(apiUrl).then(handleResponse);
            
        }
        function handleSubmit(event){
            event.preventDefault();
            searching();
        }
        function handleCity(event) {
            setCity(event.target.value);
            
            
        }

    
    if (ready) {
        return(
            <div className="Weather">
             <form onSubmit={handleSubmit} >
                 <div className="row">
                    <div className="col-9">
                        <input type="search" placeholder="Enter a city" onChange={handleCity} className="form-control" autoFocus="on"/>
                    </div>
                    <div className="col-3">
                        <input type="submit" value="Search" className="btn btn-primary w-100"/>
    
                    </div>
    
                 </div>
             </form>
                <div className="row mt-5 ">
                        
                   <div className="col-8">
                   <h1 >{weatherData.city}</h1>
                   
                 <ul>
                       
                        <li>  <FormatDate date ={weatherData.date}/>   </li>
                        <li  className="text-capitalize">{weatherData.description}</li>
                        <li>Humidity: {weatherData.humidity}%, Wind: {weatherData.wind}km/h </li>
                        
                        
                    </ul>
                      
                 </div>
                 <div className="col-4">
                     <div className="clearfix">
                        <WeatherIcon code= {weatherData.icon} size= {52}/>
                        <WeatherTemperature Celsuis= {Math.round(weatherData.Temperature)}/>
                         
                      </div>    
                 </div>
    
              </div>
              <WeatherForecast coordinates= {weatherData.coordinates}/>
            
          </div>
        )
        
    } else {
        searching();
        return "Not found..."
        
    }
    
      
}